import { render, staticRenderFns } from "./LightSwitchDevicePanelControl.vue?vue&type=template&id=5ee8733a&lang=pug&"
import script from "./LightSwitchDevicePanelControl.vue?vue&type=script&lang=ts&"
export * from "./LightSwitchDevicePanelControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports